module.exports = __webpack_public_path__ + "img/logo.956ed3f7.png";